import { useServices } from "./useServices.js";
const useValidationService = ()=>useServices().validation;
export { useValidationService };
